import React from 'react';
import styles from '../../../styles/sessions.scss';
import classNames from 'classnames';

const SessionsTimeInput = React.createClass({
  getInitialState: function () {
    return {
      from: this.secondsToTime(this.props.from),
      to: this.secondsToTime(this.props.to)
    };
  },
  componentDidUpdate(prevProps) {
    if (prevProps.from !== this.props.from || prevProps.to !== this.props.to) {
      this.setState({
        from: this.secondsToTime(this.props.from),
        to: this.secondsToTime(this.props.to)
      });
    }
  },
  pad: function (v) {
    return (v < 10 ? '0' : '') + v;
  },

  secondsToTime: function (seconds) {
    let hour = parseInt(seconds / 60 / 60);
    let minutes = parseInt((seconds - hour * TIME_HOUR) / 60);
    return this.pad(hour) + ":" + this.pad(minutes);
  },


  handleChangeFrom(e) {
    this.setState({from: e.target.value});

    if (this.props.onChange) {
      let r1 = e.target.value.match(/(\d\d):(\d\d)/);
      let r2 = this.state.to.match(/(\d\d):(\d\d)/);
      if (r1 && r2) {
        let t1 = TIME_HOUR * parseInt(r1[1]) + TIME_MIN * parseInt(r1[2]);
        let t2 = TIME_HOUR * parseInt(r2[1]) + TIME_MIN * parseInt(r2[2]);

        if (t2 >= t1 && t1 >= 0 && t2 <= TIME_DAY)
          this.props.onChange(t1, t2);
      }
    }
  },

  handleChangeTo(e) {
    this.setState({to: e.target.value});

    if (this.props.onChange) {
      let r1 = this.state.from.match(/(\d\d):(\d\d)/);
      let r2 = e.target.value.match(/(\d\d):(\d\d)/);
      if (r1 && r2) {
        let t1 = TIME_HOUR * parseInt(r1[1]) + TIME_MIN * parseInt(r1[2]);
        let t2 = TIME_HOUR * parseInt(r2[1]) + TIME_MIN * parseInt(r2[2]);

        if (t2 >= t1 && t1 >= 0 && t2 <= TIME_DAY)
          this.props.onChange(t1, t2);
      }
    }
  },

  render: function () {
    return (<div style={{display: 'inline'}}>
      <input value={this.state.from} id={styles.time_input} onChange={this.handleChangeFrom}
             disabled={this.props.disabled}/>
      -
      <input value={this.state.to} id={styles.time_input} onChange={this.handleChangeTo}
             disabled={this.props.disabled}/>
    </div>);
  }
});

export default SessionsTimeInput;



// WEBPACK FOOTER //
// ./src/js/Component/Sessions/TimeInput.jsx